import { createContextFactory } from '@streem/toolbox';
export const [HoursOfOperationProvider, useHoursOfOperation] = createContextFactory('HoursOfOperation');
//# sourceMappingURL=hours_of_operation.js.map